<div class="document-main-container">
  @if(!documents){
  <div><code>Loading ...</code></div>
  }
  @else{

  <app-drag-drop-upload [multiple]="false" [files]="files"></app-drag-drop-upload>

  <mat-card>
    <mat-card-content>
      @if(formGroup){
      <form [formGroup]="formGroup">
        <mat-form-field>
          <mat-label>{{ 'global.month' | translate }}:</mat-label>
          <mat-select formControlName="selectedMonth">
            @for (month of months; track $index; let idx=$index) {
            <mat-option [value]="idx">{{month}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'global.year' | translate }}:</mat-label>
          <mat-select formControlName="selectedYear">
            @for (year of years; track $index;) {
            <mat-option [value]="year">{{year}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field style="width:33%">
          <mat-label>{{ 'client.documents.friendly-name' | translate }}:</mat-label>
          <input matInput type="text" placeholder="{{ 'client.documents.file-name' | translate }}" formControlName="selectedFile" />
          <span matTextSuffix><mat-icon aria-hidden="true">description</mat-icon></span>
        </mat-form-field>
        <button matButton="filled" (click)="upload()" [disabled]="formGroup.invalid">
          <mat-icon aria-hidden="true">upload_file</mat-icon>
          {{ 'client.documents.upload' | translate }}
        </button>
      </form>
      }
    </mat-card-content>
  </mat-card>
  <div class="document-container">
    @for(year of documents.years; track $index){
    <h2>{{ year.year }}</h2>
    <div class="document-group-year">

      @for(month of year.months;track $index){
      <h4>{{month.month}}</h4>
      <div class="document-group-month">

        @for(document of month.documents;track $index){
        <div class="document">
          <mat-card>
            <mat-card-header>
              <mat-card-title><mat-icon aria-hidden="false" aria-label="File icon">description</mat-icon> {{ document.displayName }}</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
              <mat-card-subtitle><small>{{ 'client.documents.uploaded-at' | translate }}: {{ document.uploadDate | date: 'MMM dd, yyyy hh:mm a' }}</small></mat-card-subtitle>
              <mat-card-subtitle><small>{{ 'client.documents.uploaded-by' | translate }}: {{ document.recordCreatedUserName }}</small></mat-card-subtitle>
            </mat-card-header>
            <mat-card-actions align="end">
              <button matButton (click)="download(document.id)">{{ 'buttons.download' | translate }}</button>
              <button matButton (click)="remove(document.id)">{{ 'buttons.delete' | translate }}</button>
            </mat-card-actions>
          </mat-card>
        </div>
        }

      </div>
      }

    </div>
    }
  </div>
  @if(documents.years.length === 0){
  <mat-card class="no-data-found">
    <mat-card-content>
      -- {{ 'global.no-data' | translate }} --
    </mat-card-content>
  </mat-card>
  }
  }
</div>

